



// extend the window interface to include custom methods
export {};  // needed to declare global variables in a module
declare global {
  interface Window {
    gettext: (str: string) => string;
    ngettext: (singular: string, plural: string, n: number) => string;
    npgettext: (context: string, singular: string, plural: string, n: number) => string;
    interpolate: (fmt: string, obj: any[], named?: boolean) => string;
  }
}
if (typeof window.gettext === "undefined") {
  window.gettext = (str: string): string => {
    return str;
  }
}
if (typeof window.ngettext === "undefined") {
  window.ngettext = (singular: string, plural: string, n: number): string => {
    return n > 1 ? plural : singular;
  }
}
if (typeof window.npgettext === "undefined") {
  window.npgettext = (context: string, singular: string, plural: string, n: number): string => {
    return n > 1 ? plural : singular;
  }
}
if (typeof window.interpolate === "undefined") {
    window.interpolate = function(fmt, obj, named) {

        // Support both positional (%s) and named (%(name)s) interpolation
        if (named) {

            // Named placeholders: %(key)s
            return fmt.replace(/%\(([^)]+)\)s/g, function(match, key) {
                var value = obj && Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : "";
                return String(value);
            });
        } else {

            // Positional placeholders: %s
            var arr = Array.isArray(obj) ? obj.slice() : [obj];
            var idx = 0;
            return fmt.replace(/%s/g, function() {
                var value = idx < arr.length ? arr[idx++] : "";
                return String(value);
            });
        }
    };
}






// ts: click toggle for accounts menu (NOTE: < 990px only)
const accountButton = document.querySelector("#parent-accounts > a") as HTMLAnchorElement | null;
if (accountButton) {
  accountButton.addEventListener("click", (e: MouseEvent) => {
	e.preventDefault();
	if (window.innerWidth < 990) {
    const dropdownMenu = (e.target as HTMLElement).closest("#parent-accounts")?.querySelector(".dropdown-menu") as HTMLElement | null;
    dropdownMenu?.classList.toggle('show');
	}
  });
}



// ts: lazy loading images
document.addEventListener('lazybeforeunveil', (event: Event) => {
  const target = event.target as HTMLElement;
  const bg = target.getAttribute('data-bg');
  if (bg) {
    target.style.backgroundImage = `url(${bg})`;
  }
}, {passive: true});



// ts: Canadian shipping notice on donate and giveaway forms
const canadaShippingNotice = document.querySelector("div[data-type='canada-shipping-notice']") as HTMLElement | null;
const countryDropdown = document.getElementById("formtools_country") as HTMLSelectElement | null ||
                        document.getElementById("id_country") as HTMLSelectElement | null;

document.addEventListener("DOMContentLoaded", () => {
  if (canadaShippingNotice && countryDropdown) {
    canadaShippingNotice.hidden = true;
    countryDropdown.addEventListener("change", (event: Event) => {
      const target = event.target as HTMLSelectElement;
      canadaShippingNotice.hidden = target.value !== "CA";
    });
  }
});



// ts: language menu on click
const languageSelect = document.querySelector("#parent-languages a.language-select") as HTMLAnchorElement | null;

languageSelect?.addEventListener("click", (event: MouseEvent) => {
  event.preventDefault();
  const submenu = languageSelect.nextElementSibling as HTMLElement | null;
  if (submenu && submenu.classList.contains("dropdown-menu")) {
    submenu.classList.toggle("show");
  }
  event.stopPropagation();
});



